import { render, staticRenderFns } from "./current_country_residence.vue?vue&type=template&id=23af9871&"
import script from "./current_country_residence.vue?vue&type=script&lang=js&"
export * from "./current_country_residence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports